import React, { useEffect, useState } from "react";
import HeaderDropdown from "../HeaderDropdown";
import MatchTitle from "../items/MatchTitle";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";
import LiveMatchContainer from "../cards/LiveMatchContainer";
import TeamHolder from "../../assets/TeamHolder.svg";
import TeamHolder2 from "../../assets/TeamHolder2.svg";
import Vs from "../../assets/VsBrownIcon.svg";
import {
  isMobile,
  LiveScoreType,
  mapAbbrToLogo,
  mapAbbrToLogoWithURL,
  QuestionType,
} from "../../types/type";
import { MatchType } from "../MatchHeaderDropdown";
import { UserPick } from "../../services";
import Congra from "../../assets/CongraIcon.svg";

interface SegmentProps {
  matchHasStarted?: boolean;
  matchWillStartIn?: string;
  match: MatchType;
  amount?: string;
  answer?: UserPick[];
  onPlayAnother?: () => void;
  onPick?: () => void;
  onLeaderBoard?: () => void;
}

function CongradulationsSegment({
  matchHasStarted,
  matchWillStartIn,
  match,
  amount,
  answer,
  onLeaderBoard,
  onPick,
  onPlayAnother,
}: SegmentProps) {
  const handleLeaderBoard = () => {
    if (onLeaderBoard) {
      onLeaderBoard();
    }
  };

  const handlePick = () => {
    if (onPick) {
      onPick();
    }
  };

  const handlePlayAnother = () => {
    if (onPlayAnother) {
      onPlayAnother();
    }
  };

  return (
    <div
      className="relative flexColumn itemsCenter"
      style={{ marginBottom: 100 }}
    >
      <MatchTitle />
      <HeaderDropdown
        ajioIconHeight={isMobile ? 98 : 140}
        ajioIconWidth={isMobile ? 98 : 140}
      >
        <div className="otherLiveScoreBoardHeader">
          <img
            src={Congra}
            alt=""
            style={{ width: 75, height: 75, objectFit: "contain" }}
          />
          <CustomText
            size="large"
            weight="400"
            spacing={4}
            color={Colors.blueGray}
            textAlign="center"
            style={{ width: "90%", maxWidth: 440 }}
            marginTop={30}
          >
            CONGRATULATIONS
          </CustomText>

          <CustomText
            size="smallMedium"
            weight="400"
            marginTop={15}
            color={Colors.white}
          >
            Your picks have been submitted
          </CustomText>
        </div>
      </HeaderDropdown>
      <div
        style={{
          marginTop: -100,
          position: "relative",
          width: "100%",
          height: 150,
        }}
      >
        <div
          style={{
            width: "100%",
            alignItems: "center",
            flexDirection: "column",
            display: "flex",
            zIndex: 1,
          }}
        >
          <img src={TeamHolder} alt="" className="otherTeamHolderImage" />
          <img src={TeamHolder2} alt="" className="otherTeamHolderImage2" />
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            top: 0,
            position: "absolute",
          }}
        >
          <div className="otherTeamHolderContent">
            <div
              style={{
                flex: 1,
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <img
                src={mapAbbrToLogoWithURL(match, false).logo}
                style={{
                  width: isMobile ? 55 : 90,
                  height: isMobile ? 55 : 90,
                  objectFit: "contain",
                }}
                alt=""
              />
            </div>

            <img
              src={Vs}
              style={{
                width: isMobile ? 55 : 80,
                height: isMobile ? 55 : 80,
                objectFit: "contain",
                display: "flex",
                flex: 1,
                marginTop: isMobile ? 60 : 80,
              }}
              alt=""
            />

            <div
              style={{
                flex: 1,
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={mapAbbrToLogoWithURL(match, true).logo}
                style={{
                  width: isMobile ? 55 : 90,
                  height: isMobile ? 55 : 90,
                  objectFit: "contain",
                }}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="otherCongraChoiceButton"
        onClick={handlePlayAnother}
        style={{ marginTop: isMobile ? 50 : 100, marginBottom: 20 }}
      >
        <CustomText
          textAlign="center"
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          spacing={3}
          weight="600"
          color={Colors.primary}
          size={isMobile ? "smallMedium" : "smallMedium"}
        >
          PLAY ANOTHER MATCH
        </CustomText>
      </div>

      <div className="otherCongraChoiceButton" onClick={handlePick}>
        <CustomText
          textAlign="center"
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          spacing={3}
          weight="600"
          color={Colors.primary}
          size={isMobile ? "smallMedium" : "smallMedium"}
        >
          GO TO YOUR PICKS
        </CustomText>
      </div>

      <div
        className="buttonCheckOutWeeklyLeaderBoard"
        onClick={handleLeaderBoard}
        style={{ marginTop: 70, marginBottom: 20 }}
      >
        <CustomText
          textAlign="center"
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          color={Colors.primary}
          size={isMobile ? "small" : "smallMedium"}
        >
          CHECK OUT THE LEADERBOARD
        </CustomText>
      </div>
    </div>
  );
}

export default CongradulationsSegment;
